
import React, { Component}  from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import { UserContext } from 'components/User';
import { YellowButton } from 'ui/Button';
import Layout from 'components/Dashboard/Layout';
import { ClientAddForm } from './AddForm';


export default class ClientAdd extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Новый клиент';
  }

  onDetail = (item) => {
    this.props.history.push(`/client`);
  };

  render() {
    return (
      <FormProvider
        url={'client'}
        postSave={(item) => this.onDetail(item)}
        item={{
          name: '',
          is_active: true,
          department: this.context.data.department_active,
          counterparties: [{
            name: '',
            inn: '',
            contacts: [{name: '', emails: []}]
          }]
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <Layout>

              <Layout.Header
                title={'Добавление клиента'}
                backUrl={'/client'}
              />

              <Layout.ContentSimple>

                <ClientAddForm />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                    loading={loading}
                  >
                    Создать клиента
                  </YellowButton>
                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
